import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { showTitle, routeEqual } from '@/libs/util';
import beforeClose from '@/router/before-close';
export default {
  name: 'TagsNav',
  props: {
    value: Object,
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      tagBodyLeft: 0,
      rightOffset: 40,
      outerPadding: 4,
      contextMenuLeft: 0,
      contextMenuTop: 0,
      visible: false,
      menuList: {
        others: '关闭其他',
        all: '关闭所有'
      }
    };
  },
  computed: {
    currentRouteObj: function currentRouteObj() {
      var _this$value = this.value,
          name = _this$value.name,
          params = _this$value.params,
          query = _this$value.query;
      return {
        name: name,
        params: params,
        query: query
      };
    }
  },
  methods: {
    handlescroll: function handlescroll(e) {
      var type = e.type;
      var delta = 0;

      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = e.wheelDelta ? e.wheelDelta : -(e.detail || 0) * 40;
      }

      this.handleScroll(delta);
    },
    handleScroll: function handleScroll(offset) {
      var outerWidth = this.$refs.scrollOuter.offsetWidth;
      var bodyWidth = this.$refs.scrollBody.offsetWidth;

      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset);
      } else {
        if (outerWidth < bodyWidth) {
          if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {
            this.tagBodyLeft = this.tagBodyLeft;
          } else {
            this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, outerWidth - bodyWidth);
          }
        } else {
          this.tagBodyLeft = 0;
        }
      }
    },
    handleTagsOption: function handleTagsOption(type) {
      var _this = this;

      if (type.includes('all')) {
        // 关闭所有，除了home
        var res = this.list.filter(function (item) {
          return item.name === _this.$config.homeName;
        });
        this.$emit('on-close', res, 'all');
      } else if (type.includes('others')) {
        // 关闭除当前页和home页的其他页
        var _res = this.list.filter(function (item) {
          return routeEqual(_this.currentRouteObj, item) || item.name === _this.$config.homeName;
        });

        this.$emit('on-close', _res, 'others', this.currentRouteObj);
        setTimeout(function () {
          _this.getTagElementByName(_this.currentRouteObj.name);
        }, 100);
      }
    },
    handleClose: function handleClose(current) {
      var _this2 = this;

      if (current.meta && current.meta.beforeCloseName && current.meta.beforeCloseName in beforeClose) {
        new Promise(beforeClose[current.meta.beforeCloseName]).then(function (close) {
          if (close) {
            _this2.close(current);
          }
        });
      } else {
        this.close(current);
      }
    },
    close: function close(route) {
      var res = this.list.filter(function (item) {
        return !routeEqual(route, item);
      });
      this.$emit('on-close', res, undefined, route);
    },
    handleClick: function handleClick(item) {
      this.$emit('input', item);
    },
    showTitleInside: function showTitleInside(item) {
      return showTitle(item, this);
    },
    isCurrentTag: function isCurrentTag(item) {
      return routeEqual(this.currentRouteObj, item);
    },
    moveToView: function moveToView(tag) {
      var outerWidth = this.$refs.scrollOuter.offsetWidth;
      var bodyWidth = this.$refs.scrollBody.offsetWidth;

      if (bodyWidth < outerWidth) {
        this.tagBodyLeft = 0;
      } else if (tag.offsetLeft < -this.tagBodyLeft) {
        // 标签在可视区域左侧
        this.tagBodyLeft = -tag.offsetLeft + this.outerPadding;
      } else if (tag.offsetLeft > -this.tagBodyLeft && tag.offsetLeft + tag.offsetWidth < -this.tagBodyLeft + outerWidth) {
        // 标签在可视区域
        this.tagBodyLeft = Math.min(0, outerWidth - tag.offsetWidth - tag.offsetLeft - this.outerPadding);
      } else {
        // 标签在可视区域右侧
        this.tagBodyLeft = -(tag.offsetLeft - (outerWidth - this.outerPadding - tag.offsetWidth));
      }
    },
    getTagElementByName: function getTagElementByName(route) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.refsTag = _this3.$refs.tagsPageOpened;

        if (_this3.refsTag) {
          _this3.refsTag.forEach(function (item, index) {
            if (routeEqual(route, item.$attrs['data-route-item'])) {
              var tag = _this3.refsTag[index].$el;

              _this3.moveToView(tag);
            }
          });
        }
      });
    },
    contextMenu: function contextMenu(item, e) {
      if (item.name === this.$config.homeName) {
        return;
      }

      this.visible = true;
      var offsetLeft = this.$el.getBoundingClientRect().left;
      this.contextMenuLeft = e.clientX - offsetLeft + 10;
      this.contextMenuTop = e.clientY - 64;
    },
    closeMenu: function closeMenu() {
      this.visible = false;
    }
  },
  watch: {
    '$route': function $route(to) {
      this.getTagElementByName(to);
    },
    visible: function visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    console.log(this.list);
    setTimeout(function () {
      _this4.getTagElementByName(_this4.$route);
    }, 200);
  }
};